import { StoryState } from '../states';
import { storyActions } from '../actions';
import { StoryEntity } from '../entities';
import { storyAdapter, initialState } from '../adapters/story.adapter';


export function storyReducer(state = initialState, action: storyActions.Actions): StoryState {
    switch (action.type) {

        case storyActions.ActionTypes.LOAD: {
            return {
                ...state,
                isLoaded: false,
                isLoading: true
            };
        }

        case storyActions.ActionTypes.LOAD_SUCCESS: {
            const entities = action.response.result.map(item => new StoryEntity(item));
            const newSate = storyAdapter.setAll(entities, state);
            return {
                ...newSate,
                isLoading: false,
                isLoaded: true,
                nextUrl: action.response.next,
                prevUrl: action.response.prev,
                totalCount: action.response.count
            };
        }

        case storyActions.ActionTypes.LOAD_FAIL: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false
            };
        }

        default: {
            return state;
        }
    }
}